import React, { ReactNode } from "react";
import GridItem from "components/Grid/GridItem.js";
import GridContainer from "components/Grid/GridContainer.js";
import Card from "components/Card/Card.js";
import CardHeader from "components/Card/CardHeader.js";
import CardBody from "components/Card/CardBody.js";
import { withStyles, createStyles } from '@mui/styles';
import ApiFailed from '../../Utils/ApiFailed';
import ClipLoader from "react-spinners/ClipLoader";
import { Redirect } from "react-router-dom";
import MoreHorizIcon from '@mui/icons-material/MoreHoriz';
import IconButton from '@mui/material/IconButton';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import { APIGetLoggerAlarmsModel, buildAPIGetLoggerAlarmsModel } from "models/APIGetLoggerAlarmsModel";
import MaterialButton from '@mui/material/Button';
// DevExtreme
import { DataGrid, Column, Export, GroupPanel, Grouping, FilterRow, Pager, Paging, StateStoring } from 'devextreme-react/data-grid';
import { Workbook } from 'exceljs';
import { saveAs } from 'file-saver';
import { exportDataGrid } from 'devextreme/excel_exporter';

//Moment date/time formatting
//https://momentjs.com/docs/
import moment from 'moment';

import { CreateUrl, CallGetAPI } from 'Utils/ApiHelper.js';
import dxDataGrid, { dxDataGridRowObject } from "devextreme/ui/data_grid";
import { Chip, useTheme } from '@mui/material';
import deMessages from "devextreme/localization/messages/de.json";
import frMessages from "devextreme/localization/messages/fr.json";
import esMessages from "devextreme/localization/messages/es.json";
import ptMessages from "devextreme/localization/messages/pt.json";
import { locale, loadMessages } from "devextreme/localization";
import { injectIntl, FormattedMessage } from 'react-intl';
import { isLCLLogger } from 'variables/chariotProductIds';


const styles: Record<string, any> = {
    cardCategoryWhite: {
        "&,& a,& a:hover,& a:focus": {
            color: "rgba(255,255,255,.62)",
            margin: "0",
            fontSize: "14px",
            marginTop: "0",
            marginBottom: "0"
        },
        "& a,& a:hover,& a:focus": {
            color: "#FFFFFF"
        }
    },
    cardTitleWhite: {
        color: "#FFFFFF",
        display: "inline",
        marginTop: "0px",
        minHeight: "auto",
        fontWeight: "300",
        fontFamily: "'Roboto', 'Helvetica', 'Arial', sans-serif",
        marginBottom: "3px",
        textDecoration: "none",
        "& small": {
            color: "#777",
            fontSize: "65%",
            fontWeight: "400",
            lineHeight: "1"
        }
    }
};

const style = createStyles(styles);


interface DeviceData {
    id: number;
    serial: string;
    site: string;
    model: string;
    channels: string;
    lastConnected: Date | null;
    alarmState: string;
    siteId: number | null;
    siteName: string;
    siteRef: string;
    deployed: string;
    sendToLogger: boolean;
    updateRequested: Date | null;
    updateConfirmed: Date | null;
    firmwareToUpdate: number | null;
    firmwareSent: Date | null;
    firmwareConfirmed: Date | null;
    gpsLatitude: number | null;
    gpsLongitude: number | null;
    configurationId: string;
    undeploy: boolean;
    shutdown: boolean;
    dormant: boolean;
    company: string;
    modelId: string;
    channelsAvail: number;
    meterConfig: number;
    favourite: boolean;
    transmissionFrequency: number;
}


interface Props {
    classes: {
        cardTitleWhite: string;
        cardCategoryWhite: string;
    };
    history: {
        showBackButton: boolean;      
        goBack: () => void;
    };
    deviceData: DeviceData[]
}

interface State {
    loading: boolean;
    tableHidden: boolean;
    authorized: boolean;
    visible: boolean;
    alarms: APIGetLoggerAlarmsModel[];
    tempAlarm: APIGetLoggerAlarmsModel | undefined;
    anchorEl: EventTarget & HTMLButtonElement | null;
    redirect: boolean;
    redirectPath: string | undefined;
    redirectProps: { serial: number | undefined } | undefined;
}

class AlarmList extends React.Component<Props, State> {

    gridRef: React.RefObject<DataGrid>;

    constructor(props: Props | Readonly<Props>) {
        super(props);
        // Ref to Datagrid to store Page, Sort & Filters
        this.gridRef = React.createRef();
        locale(sessionStorage.getItem('language'));
        loadMessages(frMessages);
        loadMessages(deMessages);
        loadMessages(esMessages);
        loadMessages(ptMessages);

        this.state = {
            tableHidden: false,
            visible: false,
            alarms: [],
            tempAlarm: undefined,
            anchorEl: null,
            loading: true,
            authorized: true,
            redirect: false,
            redirectPath: undefined,
            redirectProps: undefined
        };

    }
    get dataGrid(): dxDataGrid | undefined {
        return this.gridRef.current?.instance;
    }

    componentDidMount(): void {
        let alarmData = new Array<APIGetLoggerAlarmsModel>();

        const me = this;

        CallGetAPI(CreateUrl('/api/aquaguard/ActiveAlarms?companyId=' + sessionStorage.getItem('companyId') + '&filterGroup=' + sessionStorage.getItem('filterGroupId')), {})
            .then(data => {
                if (data?.length > 0) {
                    // Copy the data records into deviceData, adding the clickEvent
                    alarmData = buildAPIGetLoggerAlarmsModel(data);

                    me.setState(
                        {
                            alarms: alarmData,
                            tableHidden: false,
                            loading: false
                        })
                }
                else {
                    me.setState(
                        {
                            alarms: [],
                            tableHidden: false,
                            loading: false
                        })
                }
            })
            .catch(function (ex) {
                console.log(ex);
                me.setState(
                    {
                        authorized: false
                    })
            });

    }
    handleClick(event: React.MouseEvent<HTMLButtonElement, MouseEvent>, id: dxDataGridRowObject): void {   //React.MouseEvent<HTMLButtonElement, MouseEvent>
        const alarm = this.state.alarms.find((row) => row.id === id.key);

        this.setState(
            {
                tempAlarm: alarm,
                anchorEl: event.currentTarget
            });
    }

    handleClose = (): void => {
        this.setState({ anchorEl: null });
    }


   

    deviceOverviewClick = (serial: number | null, model: string | null): void => {

        const device = this.props.deviceData.find(d => d.serial === serial)

        this.setState({tempDevice: device})
        this.setState(
            {
                redirect: true,
                //redirectPath: this.state.tempDevice?.model != "LCL" ? '/portal/DeviceDetail' : '/portal/LCLDeviceDetail',
                redirectPath: !isLCLLogger(model ? model : device?.model) ? '/portal/DeviceDetail' : '/portal/LCLDeviceDetail',
                redirectProps: {
                    serial: typeof (serial) === 'number' ? serial : this.state.tempDevice?.serial,
                    mapKey: this.props.mapKey
                }
            });
    }

    dateColumnCustomizeText(cellInfo: any): string {
        if (cellInfo.value == null)
            return "";
        else
            return moment(cellInfo.value).format("DD/MM/YYYY HH:mm:ss");
    }

    onExporting(e: any): void {
        const workbook = new Workbook();
        const worksheet = workbook.addWorksheet('Readings');

        exportDataGrid({
            component: e.component,
            worksheet: worksheet
        }).then(function () {
            workbook.xlsx.writeBuffer()
                .then(function (buffer: Buffer) {
                    saveAs(new Blob([buffer], { type: 'application/octet-stream' }), window.location.hostname.includes('zonelog.net') ? 'ZONELOG Export.xlsx' : 'Aquaguard Export.xlsx');
                });
        });
        e.cancel = true;
    }

    moreRender(key: dxDataGridRowObject): ReactNode {
        return (
            <IconButton size="small" onClick={(e: React.MouseEvent<HTMLButtonElement, MouseEvent>): void => { this.handleClick(e, key); }}><MoreHorizIcon /></IconButton>
        );
    }

    serialColumnTemplate(item: any): ReactNode {
        const theme = useTheme();

        if (item == null) return <div></div>;
        else {
            return <div style={{ float: "right" }}>
                <Chip
                    label={item.data.loggerSerial}
                    sx={{ backgroundColor: theme.palette.grey.main, color: theme.palette.grey.contrastText }}
                    onClick={(): void => this.deviceOverviewClick(item.data.loggerSerial, item.data.model)}
                />
            </div>
        }
    }
    buttonRender(item): ReactNode {

        return <MaterialButton variant="contained" color="secondary" onClick={(): void => this.deviceOverviewClick(item.data.loggerSerial, item.data.model)}>{this.props?.intl.formatMessage({ id: 'Overview' })}</MaterialButton>
    }

    render(): ReactNode {
        const { classes, history, intl } = this.props;

        return (this.state.authorized) ? //if we are authorized, show page, else redirect to login page
            (
                 (!this.state.redirect) ?
                (<div>

                    {this.state.loading &&
                        <div style={{
                            position: 'absolute', left: '50%', top: '50%',
                            transform: 'translate(-50%, -50%)'
                        }}>
                            <ClipLoader
                                size={150}
                                color={"#123abc"}
                                loading={this.state.loading}
                            />
                        </div>
                    }
                    {!this.state.loading &&
                        <div>

                            {this.state.tableHidden &&

                                    <ApiFailed />
                            }
                            {!this.state.tableHidden &&
                                <GridContainer>
                                    <GridItem xs={12} sm={12} md={12}>
                                        <Card>
                                        <CardHeader color="primary">
                                            <div style={{ display: 'inline' }}>

                                              {this.props.history.showBackButton &&
                                              <IconButton
                                                  style={{ display: 'inline' }}
                                                  onClick={(): void => this.props.history.goBack()}
                                                  size="large"><ArrowBackIcon style={{ fill: "white" }} /></IconButton>
                                              }
                                            <h4 className={classes.cardTitleWhite}>{intl.formatMessage({ id: 'Active Alarms' })}</h4>
                                            </div>
                                            <p className={classes.cardCategoryWhite}>
                                                {intl.formatMessage({ id: 'Active alarms identified with the server' })}
                                            </p>
                                        </CardHeader>
                                        <CardBody>
                                            <DataGrid
                                            dataSource={this.state.alarms}
                                            keyExpr="id"
                                            ref={this.gridRef}
                                            onExporting={this.onExporting} >
                                            <StateStoring enabled={true} type="localStorage" storageKey="alarmListGrid" />
                                            <Export enabled={true} />
                                            <GroupPanel visible={true} />
                                            <Grouping autoExpandAll={true} />
                                            <FilterRow visible={true} />
                                            <Column dataField="id" visible={false} dataType="number" />
                                            <Column dataField="alarmMask" visible={false} dataType="number" />
                                            <Column dataField="siteNameUserFriendly" caption={intl.formatMessage({ id: "Site Name" })} dataType="string" />
                                            <Column dataField="siteName" caption={intl.formatMessage({ id: "Site Ref" })} dataType="string" />
                                            <Column dataField="loggerSerial" caption={intl.formatMessage({ id: 'Serial' })} cellRender={this.serialColumnTemplate.bind(this)} />
                                            <Column dataField="alarmMessage" dataType="string" caption={intl.formatMessage({ id: 'Alarm Message' })} />
                                            <Column dataField="dateCreated" customizeText={this.dateColumnCustomizeText} dataType="datetime" caption={intl.formatMessage({ id: 'Date Created' })} />
                                            <Column dataField="dateRecorded" customizeText={this.dateColumnCustomizeText} dataType="datetime" caption={intl.formatMessage({ id: "Date Recorded" })} />
                                            <Column dataField="dateCleared" customizeText={this.dateColumnCustomizeText} dataType="datetime" caption={intl.formatMessage({ id: 'Date Cleared' })} />
                                            <Column dataField="source" dataType="string" caption={intl.formatMessage({ id: "Source" })} />
                                            <Column dataField="cleared" dataType="string" caption={intl.formatMessage({ id: 'Cleared' })} />
                                            <Column dataField="alarmState" dataType="number" caption={intl.formatMessage({ id: "Alarm State" })} />
                                            <Column type="buttons" cellRender={this.buttonRender.bind(this)} fixed={true} />
                                            {/*<Column type="buttons" cellRender={this.moreRender.bind(this)} fixed={true} fixedPosition="right" />*/}

                                            <Pager allowedPageSizes={[10, 20, 50, 200]} showPageSizeSelector={true} />
                                            <Paging defaultPageSize={10} />
                                            </DataGrid>
                                        </CardBody>
                                        </Card>
                                    </GridItem>
                                </GridContainer>
                            }
                        </div>
                    }
                    <Menu
                        id="simple-menu"
                        anchorEl={this.state.anchorEl}
                        keepMounted
                        open={Boolean(this.state.anchorEl)}
                        onClose={this.handleClose}
                    >
                            <MenuItem onClick={this.deviceOverviewClick}>{intl.formatMessage({ id: 'Overview' })}</MenuItem>
                    </Menu>
                </div>)
                :
                 (<Redirect push to={{
                    pathname: this.state.redirectPath,
                    state: this.state.redirectProps
                }}/>)
            )
            :
            (
                <Redirect to={'/Login'} />
            );
    }
}

export default injectIntl(withStyles(style)(AlarmList))
